import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyCSCS9x8ZRzJm8ILqY4Aitxayqge8CoQi0",
  authDomain: "cocukcerrahi-a71c4.firebaseapp.com",
  projectId: "cocukcerrahi-a71c4",
  storageBucket: "cocukcerrahi-a71c4.firebasestorage.app",
  messagingSenderId: "502469992076",
  appId: "1:502469992076:web:2fd13c00398d05ee9a65a9",
  measurementId: "G-30C32SSJ4H"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 